import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import UploadSinglePic from '@comm/upload/UploadSinglePic';
import { queryCustomCategory } from '@api/crm/crm';
import { BackBtn } from '@comm/BackBtn';

const { Option } = Select;
const FormItem = Form.Item;
const { TextArea } = Input;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    queryCustomCategory().then(res => {
      if (res.statusCode === 200) {
        this.setState({});
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const key = nextProps.data.category1;
    if (!key) {
      return false;
    }
    queryCustomCategory().then(res => {
      if (res.statusCode === 200) {
        const data = res.data.map(item => {
          item.isLeaf = false;
          return item;
        });
        if (!key) {
          this.setState({});
          return;
        }
        queryCustomCategory(key).then(result => {
          if (result.statusCode === 200) {
            data.map(item => {
              if (item.key === key) {
                item.children = result.data;
              }
              return item;
            });
            this.setState({});
          }
        });
      }
    });
  }

  loadCategory = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    queryCustomCategory(targetOption.value).then(req => {
      if (req.statusCode === 200) {
        targetOption.loading = false;
        targetOption.children = req.data;
      }
    });
  };

  chaneCategory = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({
        category1: value[0],
        category2: value[1],
      });
    }
  };

  chaneRegion = value => {
    if (value.length > 0) {
      this.props.form.setFieldsValue({ province: value[0], city: value[1] });
    }
  };

  changeOrderUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      orderName: selectedOptions.props.children,
    });
  };

  changeRecommendUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      recommendName: selectedOptions.props.children,
    });
  };

  changeManagerUser = (value, selectedOptions) => {
    this.props.form.setFieldsValue({
      managerName: selectedOptions.props.children,
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit, data } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }

        values.establishedDate = values.establishedDate
          ? values.establishedDate.format('YYYY-MM-DD')
          : undefined;
        handleSubmit(values);
      }
    });
  };

  changeType = value => {
    // TODO 当是个人时隐去一些信息
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    getFieldDecorator('province', { initialValue: data ? data.province : '' });
    getFieldDecorator('city', { initialValue: data ? data.city : '' });
    getFieldDecorator('category1', {
      initialValue: data ? data.category1 : '',
    });
    getFieldDecorator('category2', {
      initialValue: data ? data.category2 : '',
    });
    getFieldDecorator('orderName', {
      initialValue: data ? data.orderName : '',
    });
    getFieldDecorator('recommendName', {
      initialValue: data ? data.recommendName : '',
    });
    getFieldDecorator('managerName', {
      initialValue: data ? data.managerName : '',
    });
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    const ItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    };

    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: 15, marginTop: '-45px' }}>
          <BackBtn />
        </div>
        <Card title="基本信息">
          <Row>
            <Col span={10}>
              <FormItem label="产品Logo" {...ItemLayout2}>
                <UploadSinglePic />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="产品名称" {...ItemLayout2}>
                {getFieldDecorator('name', {
                  initialValue: data ? data.name : '',
                })(<Input placeholder="公司名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="产品负责人" {...ItemLayout2}>
                {getFieldDecorator('type', {
                  initialValue: data ? data.type : '1',
                })(
                  <Select onChange={this.changeType}>
                    <Option key="1" value="1">
                      公司
                    </Option>
                    <Option key="0" value="0">
                      个人
                    </Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <FormItem label="产品介绍" {...ItemLayout}>
                {getFieldDecorator('type', {
                  initialValue: data ? data.type : '1',
                })(<TextArea rows={4} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <FormItem>
                <Row>
                  <Col span={5} />
                  <Col span={19}>
                    <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
                      确定
                    </Button>
                  </Col>
                </Row>
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/client/product/FormProduct.js